export enum HomeRoutePath {
    Home = '/'
}
